/*    
<summary>
   This functional component provides routing functionality. 
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary> 
<returns>Returns JSX</returns>
*/
import { observer } from "mobx-react";
import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import roleTypeEnum from "../../constants/role-type-enum";
import systemModuleEnum from "../../constants/system-module-enum";
import userTypeEnum from "../../constants/user-type-enum";
import config from "../../helpers/config-helper";
import { getRoleTypeFromLocalStorage, getUserTypeFromLocalStorage } from "../../helpers/local-stotrage-helper";
import { findRouteAccess, redirectToDefaultRoute } from "../../helpers/route-helper";
import OrganizationAccountActivation from "../../modules/account-activation/organization-account-activation";
import UserAccountActivation from "../../modules/account-activation/user-account-activation";
import AuditLog from "../../modules/audit-logs/audit-log";
import Login from "../../modules/auth/Login";
import Configuration from "../../modules/configurations/configuration";
import ResendMail from "../../modules/create-account/components/resend-email";
import CreateAccount from "../../modules/create-account/create-account";
import Dashboard from "../../modules/dashboard/Dashboard";
import BulkDeviceRegister from "../../modules/device-iccid/components/bulk-device-register";
import DeviceRegister from "../../modules/device-iccid/device-register";
import Device from "../../modules/device/Device";
import AddBulk from "../../modules/device/add-bulk/AddBulk";
import SingleView from "../../modules/documentation/components/singleView/singleView";
import Documentation from "../../modules/documentation/documentation";
import forgetPassword from "../../modules/forget-password/components/forget-password";
import FotaMzlRelease from "../../modules/fota-mzl-release/fota-mzl-release";
import Group from "../../modules/groups/group";
import Order from "../../modules/order/order";
import PaymentHistory from "../../modules/payment-history/payment-history";
import PricingMenu from "../../modules/pricing-menu/pricing-menu";
import PricingPlan from "../../modules/pricing-plan/pricing-plan";
import tenants from "../../modules/tenants/tenants";
import FotaSchedulerDeviceStatus from "../../modules/fota-tnt-release/components/fota-device-status";
import User from "../../modules/user/user";
import LayoutRoute from "./LayoutRoute";
import LoginLayoutRoute from "./LoginLayoutRoute";
import RoutesConstants from "./routes.constants";
import FotaTenantRelease from "../../modules/fota-tnt-release/fota-tnt-release"

const appConfig = config();
const isFotaEnabled = appConfig.IS_FOTA_ENABLED;

const Routes = (props: any) => {
    return (
        <React.Fragment>
            <Switch>
                <LoginLayoutRoute path={RoutesConstants.Login} component={Login} />
                <LoginLayoutRoute path={RoutesConstants.ForgetPassword} component={forgetPassword} />
                {/* <LoginLayoutRoute path={RoutesConstants.ResetPassword} component={ResetPassword} /> */}
                <LoginLayoutRoute path={RoutesConstants.CreateAccount} component={CreateAccount} />
                <Route path={RoutesConstants.OrganizationAccountActivation} component={OrganizationAccountActivation} />
                <Route path={RoutesConstants.UserAccountActivation} component={UserAccountActivation} />
                <Route path={RoutesConstants.ResendMail} component={ResendMail} />
                {findRouteAccess(systemModuleEnum.Tenant) && <LayoutRoute path={RoutesConstants.Tenants} component={tenants} />}
                <LayoutRoute path={RoutesConstants.Documentation} component={Documentation} />
                <LayoutRoute path={RoutesConstants.SingleView} component={SingleView} />
                {(findRouteAccess(systemModuleEnum.Statistics)) && <LayoutRoute path={RoutesConstants.PricingMenu} component={PricingMenu} />}
                {findRouteAccess(systemModuleEnum.Plan) && <LayoutRoute path={RoutesConstants.PricingPlan} component={PricingPlan} />}
                {(findRouteAccess(systemModuleEnum.Order)) && <LayoutRoute path={RoutesConstants.Order} component={Order} />}
                {(findRouteAccess(systemModuleEnum.Order) && getUserTypeFromLocalStorage() == userTypeEnum.SystemUser) && <LayoutRoute path={RoutesConstants.PaymentHistory} component={PaymentHistory} />}
                {findRouteAccess(systemModuleEnum.Dashboard) && <LayoutRoute path={RoutesConstants.Dashboard} component={Dashboard} />}
                {findRouteAccess(systemModuleEnum.Configuration) && <LayoutRoute path={RoutesConstants.Configurations} component={Configuration} />}
                {findRouteAccess(systemModuleEnum.Device) && <LayoutRoute path={RoutesConstants.Device} component={Device} />}
                {findRouteAccess(systemModuleEnum.Device) && <LayoutRoute path={RoutesConstants.AddBulk} component={AddBulk} />}
                {findRouteAccess(systemModuleEnum.DeviceRegisteration) && <LayoutRoute path={RoutesConstants.DeviceRegister} component={DeviceRegister} />}
                {(findRouteAccess(systemModuleEnum.DeviceRegisteration) && getUserTypeFromLocalStorage() === userTypeEnum.SystemUser) && <LayoutRoute path={RoutesConstants.BulkDeviceRegister} component={BulkDeviceRegister} />}
                {findRouteAccess(systemModuleEnum.Group) && <LayoutRoute path={RoutesConstants.Group} component={Group} />}
                {
                    isFotaEnabled && findRouteAccess(systemModuleEnum.Fota) && getUserTypeFromLocalStorage() == userTypeEnum.TenantUser &&
                    <LayoutRoute path={RoutesConstants.FotaDeviceStatus} component={FotaSchedulerDeviceStatus} />
                }
                {
                    isFotaEnabled && findRouteAccess(systemModuleEnum.Fota) && (getUserTypeFromLocalStorage() === userTypeEnum.TenantUser) &&
                    <LayoutRoute path={RoutesConstants.Fota} component={getUserTypeFromLocalStorage() == userTypeEnum.TenantUser ? FotaTenantRelease : FotaTenantRelease} />
                }
                {
                    isFotaEnabled && findRouteAccess(systemModuleEnum.Fota) && (getUserTypeFromLocalStorage() === userTypeEnum.SystemUser) &&
                    <LayoutRoute path={RoutesConstants.Fota} component={getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ? FotaMzlRelease : FotaMzlRelease} />
                }
                {findRouteAccess(systemModuleEnum.User) && <LayoutRoute path={RoutesConstants.User} component={User} />}
                {
                    (findRouteAccess(systemModuleEnum.AuditLog) && getRoleTypeFromLocalStorage() !== roleTypeEnum.ReadOnly) &&
                    <LayoutRoute path={RoutesConstants.AuditLog} component={AuditLog} />}
                <Redirect to={redirectToDefaultRoute()} />
            </Switch>
        </React.Fragment>
    );
};

export default withRouter(observer(Routes));
